<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close">
    <template v-slot:modalHeader>
      <h2 class="flex items-center">
        <IconValidate20Green class="mr-1" />Procédure lancée avec succès !
      </h2>
    </template>
    <template v-slot:modalBody>
      <div class="mb-8">
        Un email contenant un
        <b>lien sécurisé </b> va être envoyé d'ici quelques instants au
        destinataire :
      </div>
      <div
        class="mb-8 flex w-full max-w-md items-start gap-3 rounded-lg border border-blue-100 bg-refonte-pale-violet-2 p-4 text-left"
        v-if="props.signataire">
        <div class="icon-email">
          <IconEmail />
        </div>
        <div>
          <div
            class="mb-0.5 text-xs font-semibold uppercase tracking-wide text-blue-600">
            Destinataire
          </div>
          <div class="text-sm font-bold">
            {{ signataire.nomPrenom }}
          </div>
          <div class="text-sm">{{ signataire.email }}</div>
          <div class="text-sm">
            {{ signataire.telephone }}
          </div>
        </div>
      </div>
      <div>
        <b>Action requise :</b> Le destinataire devra consulter ses emails (y
        compris les spams) et cliquer sur le <b>lien sécurisé</b> pour signer le
        document.
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button v-bind:on_click="props.on_close"> Fermer </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import IconEmail from '@/assets/img/refonte/icons/information/icon-email.svg?component';
  import { InterlocuteurSignataire } from '@/types/gestion/interlocuteurs-types';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      title?: string;
      signataire: InterlocuteurSignataire;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped>
  .icon-email {
    @apply flex shrink-0 items-center justify-center;
    width: 18px;
    height: 18px;

    :deep(svg) {
      @apply text-refonte_blue-600;
      width: 18px;
      height: 18px;
    }
  }
  .icon-phone {
    @apply flex shrink-0 items-center justify-center;
    width: 14px;
    height: 14px;

    :deep(svg) {
      @apply text-refonte_blue-600;
      width: 14px;
      height: 14px;
    }
  }
</style>
